import {Routes, RouterModule} from '@angular/router';

// Module Home
import {HomeComponent} from './components/layout/body-home/home.component';

// Module Card
import {NewAccessCardComponent} from './components/layout/new-access-card/new-access-card.component';
import {NewCardsResultComponent} from './components/layout/new-cards-result/new-cards-result.component';
import {CardRepositionComponent} from './components/layout/card-reposition/card-reposition.component';
import {CardsListResultComponent} from './components/layout/cards-list-result/cards-list-result.component';
import {NewCardsListComponent} from './components/layout/new-cards-list/new-cards-list.component';
import {PickupcardsComponent} from './components/layout/pickupcards/pickupcards.component';

// Module Policy
import {PolicyListComponent} from './components/layout/policy-list/policy-list.component';
import {FormCheckPolicyComponent} from './components/layout/form-check-policy/form-check-policy.component';
import {PolicyResultComponent} from './components/layout/policy-result/policy-result.component';
import {PolicyApproverComponent} from './components/layout/policy-approver/policy-approver.component';
import {CheckPolicyManagementComponent} from './components/layout/check-policy-management/check-policy-management.component';

// Module Card Approver
import {CardApproverListComponent} from './components/layout/card-approver-list/card-approver-list.component';
import {CardApproverResultComponent} from './components/layout/card-approver-result/card-approver-result.component';

// Others
import {FaqPublicComponent} from './components/layout/faq-public/faq-public.component';
import {AuthModulesGuard} from './guards/auth-modules.guard';
import {NotFoundPageComponent} from './components/layout/not-found-page/not-found-page.component';
import { NotModulesComponent } from './components/layout/not-modules/not-modules.component';

import {EmployeAccessComponent} from './components/layout/employe-access/employe-access.component';
import {AccessConfirmationComponent} from './components/layout/access-confirmation/access-confirmation.component';
import {AccessEmployeeListComponent} from './components/layout/access-employee-list/access-employee-list.component';
import {AccessEmployeeResultComponent} from './components/layout/access-employee-result/access-employee-result.component';
import {AccessApproversListComponent} from './components/layout/access-approvers-list/access-approvers-list.component';
import {AccessContractComponent} from './components/layout/access-contract/access-contract.component';
import {AccessIncomingRequestListComponent} from './components/layout/access-incoming-request-list/access-incoming-request-list.component';
import {AccessIncomingRequestDetailsComponent} from './components/layout/access-incoming-request-details/access-incoming-request-details.component';
import {AccessExceptionComponent} from './components/layout/access-exception/access-exception.component';
import {AccessIncomingRequestConfirmComponent} from './components/layout/access-incoming-request-confirm/access-incoming-request-confirm.component';
import {AccessVisitorComponent} from './components/layout/access-visitor/access-visitor.component';
import {MyAuthorisedAccessesComponent} from './components/layout/self-verification/my-authorised-accesses/my-authorised-accesses.component';
import {MyAccessesAuthorisedDetailComponent} from './components/layout/self-verification/my-accesses-authorised-detail/my-accesses-authorised-detail.component';
import {MyQualificationListComponent} from './components/layout/self-verification/my-qualification-list/my-qualification-list.component';
import {PersonalFormAccessComponent} from './components/public/access-form-public/personal-form-access/personal-form-access.component';
import {LeaderGroupAccessFormComponent} from './components/public/access-form-public/leader-group-access-form/leader-group-access-form.component';
import {ConfirmationPublicFormComponent} from './components/public/access-form-public/confirmation-public-form/confirmation-public-form.component';
import {MedicalTestComponent} from './components/public/medical-test/medical-test.component';
import {ConfirmationMedicalComponent} from './components/public/medical-test/confirmation-medical/confirmation-medical.component';
import { SaaDelegateComponent } from './components/layout/saa-delegate/saa-delegate.component';
import { SaaDelegateConfirmationComponent } from './components/layout/saa-delegate/saa-delegate-confirmation/saa-delegate-confirmation.component';
import { ExternalVerificationComponent } from './components/layout/external-verification/external-verification.component';
import { ExternalVerificationListComponent } from './components/layout/external-verification-list/external-verification-list.component';
import { ExternalVerificationDetailsComponent } from './components/layout/external-verification-details/external-verification-details.component';
import { UnauthBackendComponent } from './components/layout/unauth-backend/unauth-backend.component';
import { VisitorVerificationComponent } from './components/layout/visitor-verification/visitor-verification.component';
import { VisitorVerificationListComponent } from './components/layout/visitor-verification-list/visitor-verification-list.component';


const APP_ROUTES: Routes = [
  // -----module card-request ->moduleid: 2
  {path: 'new-access-card', component: NewAccessCardComponent, canActivate: [AuthModulesGuard], data: {modules: [12]}},
  {path: 'card-confirmation/:id', component: NewCardsResultComponent, canActivate: [AuthModulesGuard], data: {modules: [13]}},
  {path: 'new-cards/list', component: NewCardsListComponent, canActivate: [AuthModulesGuard], data: {modules: [14]}},
  {path: 'card-reposition', component: CardRepositionComponent, canActivate: [AuthModulesGuard], data: {modules: [16]}},
  {path: 'card-detail/:id', component: CardsListResultComponent, canActivate: [AuthModulesGuard], data: {modules: [15]}},
  {path: 'pickup-cards', component: PickupcardsComponent, canActivate: [AuthModulesGuard], data: {modules: [17]}},

  // -----module card-Approver ->moduleid: 3
  {path: 'card-approver/list', component: CardApproverListComponent, canActivate: [AuthModulesGuard], data: {modules: [18]}},
  {path: 'card-approver/result/:id', component: CardApproverResultComponent, canActivate: [AuthModulesGuard], data: {modules: [19]}},

  // Module Policy Check
  {path: 'policy/checkManagement', component: CheckPolicyManagementComponent, canActivate: [AuthModulesGuard], data: {modules: [32]}},

  // -----module  Policy Request ->moduleid: 5
  {path: 'policy/detail/:mode/:id', component: PolicyResultComponent, canActivate: [AuthModulesGuard], data: {modules: [31]}},
  {path: 'policy/list', component: PolicyListComponent, canActivate: [AuthModulesGuard], data: {modules: [33]}},
  {path: 'policy/form', component: FormCheckPolicyComponent, canActivate: [AuthModulesGuard], data: {modules: [30]}},

  // module Policy Approver moduleid: 4
  {path: 'approver/list', component: PolicyApproverComponent, canActivate: [AuthModulesGuard], data: {modules: [34]}},

  // -----module Site-Access-request ->moduleid: 3
  {path: 'access-request/employee', component: EmployeAccessComponent, canActivate: [AuthModulesGuard], data: {modules: [20]}},
  {path: 'access-request/contractor', component: AccessContractComponent, canActivate: [AuthModulesGuard], data: {modules: [23]}},
  {path: 'access-request/exception', component: AccessExceptionComponent, canActivate: [AuthModulesGuard], data: {modules: [22]}},
  {path: 'other-temporary-accesses', component: AccessVisitorComponent, canActivate: [AuthModulesGuard], data: {modules: [36]}},
  {path: 'access-confirmation/:id', component: AccessConfirmationComponent, canActivate: [AuthModulesGuard], data: {modules: [21]}},
  {path: 'access-list/records', component: AccessEmployeeListComponent, canActivate: [AuthModulesGuard], data: {modules: [24]}},
  {path: 'access-list/records/:id', component: AccessEmployeeResultComponent, canActivate: [AuthModulesGuard], data: {modules: [25]}},
  {path: 'access-list/approvers', component: AccessApproversListComponent, canActivate: [AuthModulesGuard], data: {modules: [26]}},
 

  // module Site Access Approver
  {path: 'incoming-access-requests', component: AccessIncomingRequestListComponent, canActivate: [AuthModulesGuard], data: {modules: [27]}},
  {
    path: 'incoming-access-requests/details/:id',
    component: AccessIncomingRequestDetailsComponent,
    canActivate: [AuthModulesGuard],
    data: {modules: [28]}
  },
  {
    path: 'incoming-access-confirmation/:id',
    component: AccessIncomingRequestConfirmComponent,
    canActivate: [AuthModulesGuard],
    data: {modules: [29]}
  },

  // Module Self Verification
  {path: 'my-authorised-accesses', component: MyAuthorisedAccessesComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  {
    path: 'my-authorised-accesse/detail/:id',
    component: MyAccessesAuthorisedDetailComponent,
    canActivate: [AuthModulesGuard],
    data: {modules: [38]}
  },
  {path: 'my-qualifications', component: MyQualificationListComponent, canActivate: [AuthModulesGuard], data: {modules: [39]}},

  {path: 'saa-delegate', component: SaaDelegateComponent, canActivate: [AuthModulesGuard], data: {modules: [46]}},
  {path: 'saa-delegate-confirm', component: SaaDelegateConfirmationComponent, canActivate: [AuthModulesGuard], data: {modules: [47]}},

  {path: 'external-accesses', component: ExternalVerificationComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  {path: 'external-accesses/:email', component: ExternalVerificationListComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  //{path: 'external-accesses/:email/:rut', component: ExternalVerificationListComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  {path: 'external-accesses/details/:email', component: ExternalVerificationDetailsComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  {path: 'visitor-accesses', component: VisitorVerificationComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  {path: 'visitor-accesses/:email/:rut/:type', component: VisitorVerificationListComponent, canActivate: [AuthModulesGuard], data: {modules: [37]}},
  // -----module Visitors
  // put this pages url path on app.component validateVisitUrl() & interceptor;
  {path: 'personal-access-form', component: PersonalFormAccessComponent},
  {path: 'leader-access-form', component: LeaderGroupAccessFormComponent},
  {path: 'form-confirmation/:status', component: ConfirmationPublicFormComponent},
  {path: 'medical-confirmation/:status/:result', component: ConfirmationMedicalComponent},
  {path: 'medical-test', component: MedicalTestComponent},

  //  -----module Public
  {path: 'faq', component: FaqPublicComponent},  // access to basic pages [0]
  {path: '404', component: NotFoundPageComponent},
  {path: 'not-modules', component: NotModulesComponent},
  {path: 'mulesoft-error', component: UnauthBackendComponent},
  // Module Home
  {path: '', component: HomeComponent},
  {path: '**', component: NotFoundPageComponent}];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { scrollPositionRestoration: 'enabled' });
